module.exports={
	"Form": "FundCreateManifest",
	"Scope": "Fund-Create",
	"Descriptors":
	{
		"FundDetails.Name":
		{
			"Name": "Name",
			"Hash": "Fund-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Fund-Create-Identity",
				"Group": "Fund-Create-Identity"
			}
		},
		"FundDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Fund-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.Description":
		{
			"Name": "Description",
			"Hash": "Fund-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.OriginalBalance":
		{
			"Name": "Original Balance",
			"Hash": "Fund-Create-OriginalBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.TotalCommitted":
		{
			"Name": "Total Committed",
			"Hash": "Fund-Create-TotalCommitted",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.CommittedBalance":
		{
			"Name": "Committed Balance",
			"Hash": "Fund-Create-CommittedBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Fund-Create-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.TotalPendingCharge":
		{
			"Name": "Total Pending Charge",
			"Hash": "Fund-Create-TotalPendingCharge",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.ExternalAccountID":
		{
			"Name": "External Account ID",
			"Hash": "Fund-Create-ExternalAccountID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.CostCenter":
		{
			"Name": "Cost Center",
			"Hash": "Fund-Create-CostCenter",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.Active":
		{
			"Name": "Active",
			"Hash": "Fund-Create-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Fund-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Fund-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Fund-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Fund-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
